import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import HelpSteps, { type Step } from './_HelpSteps'

function ActivationHelp(): JSX.Element {
  const steps: Step[] = [
    {
      number: 1,
      content: i18n.tView('personal_settings.mfa.activation_help.step_1', {
        android_store_link: (
          <a
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
          >
            Android
          </a>
        ),

        ios_store_link: (
          <a
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://apps.apple.com/app/google-authenticator/id388497605"
          >
            iOS
          </a>
        ),
      }),
    },
    { number: 2, content: i18n.t('personal_settings.mfa.activation_help.step_2') },
    { number: 3, content: i18n.t('personal_settings.mfa.activation_help.step_3') },
  ]

  return <HelpSteps steps={steps} />
}

export default observer(ActivationHelp)
